import ComparisonMode, { ComparisonModeStrings } from 'enums/ComparisonMode'
import { SocialWebTimelineComparisonWidget } from 'schemas/SocialWebTimelineComparisonWidgetSchema'
import { TimelineComparisonWidget } from '../types'

export const isCrosstabMode = (mode: ComparisonModeStrings) =>
  ([
    ComparisonMode.THEMES,
    ComparisonMode.TAGS,
    ComparisonMode.DOC_HIERARCHIES
  ] as string[]).includes(mode)

const isSocialWebTimelineComparisonWidget = (
  setting: TimelineComparisonWidget
): setting is SocialWebTimelineComparisonWidget => 'metricNames' in setting

export const servicePropertySetter = (
  setting: TimelineComparisonWidget,
  serviceProperties: any
) => {
  const resultServiceProperties = { ...serviceProperties }
  const pivotThemeIds = []
  if (setting.pivotThemeInfos && setting.pivotThemeInfos.length > 0) {
    for (let i = 0; i < setting.pivotThemeInfos.length; i += 1) {
      pivotThemeIds.push(setting.pivotThemeInfos[i].themeId)
    }
  }

  if (setting.comparisonMode === ComparisonMode.THEMES && pivotThemeIds.length > 0) {
    resultServiceProperties.colComparisonMode = ComparisonMode.THEMES
    resultServiceProperties.themeIds = pivotThemeIds
  } else if (
    isSocialWebTimelineComparisonWidget(setting) &&
    setting.comparisonMode === ComparisonMode.TAGS &&
    setting.metricNames &&
    setting.metricNames.length > 0
  ) {
    resultServiceProperties.colComparisonMode = ComparisonMode.TAGS
    resultServiceProperties.tagNames = setting.metricNames
  } else if (
    isSocialWebTimelineComparisonWidget(setting) &&
    setting.comparisonMode === ComparisonMode.DOC_HIERARCHIES &&
    setting.metricNames &&
    setting.metricNames.length > 0
  ) {
    resultServiceProperties.colComparisonMode = ComparisonMode.DOC_HIERARCHIES
    resultServiceProperties.docNames = setting.metricNames
  } else {
    resultServiceProperties.colComparisonMode = ComparisonMode.NONE
  }

  resultServiceProperties.rowComparisonMode = ComparisonMode.TOPICS

  return resultServiceProperties
}
